import { ReactElement, useEffect } from 'react';

export const Colors: { [key: string]: any } = {
    primary: '#00BCD4',
    'primary-translucent-50': 'rgba(0, 188, 212, .5)',
    'primary-translucent-20': 'rgba(0, 188, 212, .2)',
    secondary: '#ED5244',
    'secondary-dark': '#ED5244',
    'secondary-dark-translucent-20': 'rgba(237, 82, 68, .2)',
    'secondary-dark-translucent-65': 'rgba(237, 82, 68, .65)',
    white: 'white',
    black: '#0e1111',
    'black-translucent-60': 'rgba(14,17,17,.6)',
    gray: '#eee',
    error: '#FE6465',
    'error-translucent-20': 'rgba(254, 100, 101, .2)',
    warning: '#FFD56C',
    'warning-translucent-20': 'rgba(255, 213, 108, .2)',
    success: '#7FBD5D',
    'success-translucent-20': 'rgba(127, 189, 93, .2)',
    charts: {
        green: '#7FBD5D',
        greenish: '#FFD56C',
        turquoise: '#00BCD4',
        blue: '#134153',
        gray: '#ED5244',
    },
};

interface ThemeProviderProps {
    children: ReactElement;
}

const ThemeProvider = ({ children }: ThemeProviderProps): ReactElement => {
    useEffect(() => {
        for (let key in Colors) {
            if (key === 'charts') {
                for (let key2 in Colors.charts) {
                    document.documentElement.style.setProperty(
                        `--color-charts-${key2}`,
                        Colors.charts[key2].toString()
                    );
                }
            } else {
                document.documentElement.style.setProperty(
                    `--color-${key}`,
                    Colors[key].toString()
                );
            }
        }
    }, []);

    return children;
};

export default ThemeProvider;
